import React from 'react';
import { STATUS_MAP } from './batchReportUtils';

const DISPLAY_COLOR_MAP: Record<string, string> = {
    default: 'bg-gray-500',
    info: 'bg-blue-500',
    warning: 'bg-yellow-500',
    error: 'bg-red-500',
    success: 'bg-green-500',
};

type DisplayStatusColor = 'default' | 'info' | 'warning' | 'error' | 'success';

interface ReportStatusBadgeProps {
    status?: string;
    displayStatus?: string;
    displayStatusColor?: DisplayStatusColor;
    onClick?: () => void;
    showDescription?: boolean;
}

const ReportStatusBadge: React.FC<ReportStatusBadgeProps> = ({
    status,
    displayStatus,
    displayStatusColor,
    onClick,
    showDescription,
}) => {
    const cfg = STATUS_MAP[status?.toUpperCase() || ''];
    const label = displayStatus || cfg?.label || status || '';
    const bgClass = displayStatusColor
        ? DISPLAY_COLOR_MAP[displayStatusColor] || DISPLAY_COLOR_MAP.default
        : cfg?.bgClass || 'bg-gray-500';

    const badge = (
        <span
            className={`rounded px-2 py-1 text-xs font-bold text-white ${bgClass} ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
            title={cfg?.description}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
        >
            {label}
        </span>
    );

    if (showDescription && cfg?.description) {
        return (
            <span className="inline-flex items-center gap-2">
                {badge}
                <span className="text-xs text-gray-500">{cfg.description}</span>
            </span>
        );
    }

    return badge;
};

export default ReportStatusBadge;
